import { Visualization } from 'states';
import { answersFromConfig } from './engine';
import { BuilderAnswers } from './types';

/**
 * The answers a saved KPI was built with, or null when it was written by hand. A copied KPI remembers which KPI it
 * came from; its query is read from the original again, before the baseline is taken, so reopening is never a change.
 */
export function restoreAnswers(saved: Visualization | undefined, all: Visualization[]): Partial<BuilderAnswers> | null {
  const restored = answersFromConfig(parseConfig(saved?.data?.[0]?.additionalConfig?.config));
  const original = restored?.template?.code ? all.find((v) => v.visualizationCode === restored.template?.code)?.data?.[0] : undefined;
  // Questions drawn by a handler store the handler's name in the config, so the chart shown is the one saved on the KPI.
  const savedChart = saved?.data?.[0]?.info?.chartType;
  if (restored && savedChart) restored.chart = savedChart;
  if (restored?.template && original) restored.template = { ...restored.template, query: original.data.query, config: original.additionalConfig?.config ?? '{}' };
  return restored;
}

const parseConfig = (raw?: string): Record<string, unknown> | null => {
  try {
    return raw ? (JSON.parse(raw) as Record<string, unknown>) : null;
  } catch {
    return null;
  }
};
